import { Roles } from "../../../constants/roles";
import { FormBase } from "../../../util/form-base-form";

class SearchCategoryPickerFormBase extends FormBase {
    public override queryElement<T extends Element = HTMLElement>(
        root: ParentNode | null | undefined,
        selector: string,
        elementClass?: abstract new (...args: never[]) => T,
    ): T | null {
        return super.queryElement(root, selector, elementClass);
    }
}

const formBase = new SearchCategoryPickerFormBase();

export class SearchCategoryPickerForm {
    public static getPickerRoot(root: ParentNode): HTMLElement | null {
        return formBase.queryElement(root, `[data-role="${Roles.SEARCH_CATEGORY_PICKER}"]`, HTMLElement);
    }

    public static getChips(root: ParentNode): HTMLElement | null {
        return formBase.queryElement(root, `[data-role="${Roles.SEARCH_CATEGORY_CHIPS}"]`, HTMLElement);
    }
}
